const Module = () => import('./Module.vue')
const collectorHome = () => import('./components/detailIndex.vue')
const moduleRoute = {
  path: '/collector',
  component: Module,
  children: [
    {
      path: '/legal-collector/:id/',
      name: 'legal-collector-id',
      component: collectorHome,
    },
  ],
}

export default router => {
  router.addRoutes([moduleRoute])
}
